import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import {
  Menu, Icon, Card, Image,
} from 'semantic-ui-react';
import avatarIcon from '@/assets/images/default-user-icon.png';
import Selectors from '@/auth/hooks/selectors';
import authProvider from '@/auth/authProvider';

const LoginMenuItem = () => {
  const intl = useIntl();
  const { authInProgress } = Selectors.useIsAuthenticating();
  return (
    <Card className="aridhia-user-card">
      <Card.Content>
        <Image
          src={avatarIcon}
          alt={intl.formatMessage({ id: 'header.user.avatar.alt' })}
          floated="right"
          size="mini"
        />
        <Menu.Item
          className="aridhia-logout-menu-item"
          title=""
          onClick={() => authProvider().login()}
          selected={false}
          disabled={authInProgress}
        >
          <Icon name="sign in" />
          <FormattedMessage id="header.sign.in" />
        </Menu.Item>
      </Card.Content>
    </Card>
  );
};

export default LoginMenuItem;
